import { Box } from "../../mantine-passthroughs/index.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/card/internal/CardHeader.tsx
const CardHeader = ({ children, color }) => /* @__PURE__ */ jsx(Box, {
	style: { color: color ?? "var(--mantine-color-gray-9)" },
	fz: "lg",
	fw: "600",
	children
});

//#endregion
export { CardHeader };